
export default class ByTheNumbers {
	constructor(el) {
		this.el = el;
		if (document.querySelector('.numbers__wrapper')) {
			this.numbers = document.querySelector('.numbers__wrapper');
			this.nav = document.querySelectorAll('.section--numbers nav li a');
			this.pager = document.querySelectorAll('.section--numbers .pager');
			this.slidesCount = this.nav.length;
			this.currentSlide = 0;
			this.events();
		}
	}
	
	smoothScrollPolyfill(node, key, target) {
	  const startTime = Date.now();
	  const offset = node[key];
	  const gap = target - offset;
	  const duration = 1000;
	  let interrupt = false;
	  
	  const easingOutQuint = (x, t, b, c, d) => c * ((t = t / d - 1) * t * t * t * t + 1) + b;
	
	  const step = () => {
	    const elapsed = Date.now() - startTime;
	    const percentage = elapsed / duration;
	
	    if (interrupt) {
	      return;
	    }
	
	    if (percentage > 1) {
	      cleanup();
	      return;
	    }
	    node[key] = easingOutQuint(0, elapsed, offset, gap, duration);
	    requestAnimationFrame(step);
	  };
	
	  const cancel = () => {
	    interrupt = true;
	    cleanup();
	  };
	
	  const cleanup = () => {
	    node.removeEventListener('wheel', cancel);
	    node.removeEventListener('touchstart', cancel);
	  };
	  node.addEventListener('wheel', cancel, { passive: true });
	  node.addEventListener('touchstart', cancel, { passive: true });
	
	  step();
	
	  return cancel;
	}

	testSupportsSmoothScroll() {
	  var supports = false;
	  try {
	    var div = document.createElement('div');
	    div.scrollTo({
	      top: 0,
	      get behavior() {
	        supports = true;
	        return 'smooth';
	      } });
	
	  } catch (err) {} // Edge throws an error
	  return supports;
	}
	

	events() {
		this.numbers.addEventListener('scroll', this.scrollNumbers.bind(this, this.numbers));
		for (var i = 0; i < this.nav.length; i++) {
			this.nav[i].addEventListener('click', this.scrollGoto.bind(this, this.nav[i], i));
		}
		for (var i = 0; i < this.pager.length; i++) {
			this.pager[i].addEventListener('click', this.scrollGoto.bind(this, this.pager[i], i));
		}
	}
	
	scrollGoto(el, i, e) {
		e.preventDefault();
		if (el.classList.contains('next')) {
			this.currentSlide++;
			if (this.currentSlide >= (this.slidesCount)) {
				this.currentSlide = 0;
			}
		} else if (el.classList.contains('prev')) {
			this.currentSlide--;
			if (this.currentSlide < 0) {
				this.currentSlide = this.slidesCount - 1;
			}
		} else {
			this.currentSlide = i;
		}
		//console.log('scrollGoto', this.currentSlide);
		
		if (this.currentSlide == 0) {
			var scrollLeft = 0;
		} else {
			var scrollLeft = Math.floor(this.numbers.scrollWidth * (this.currentSlide / this.slidesCount));
		}
		if (this.testSupportsSmoothScroll()) {
			this.numbers.scrollTo({
			  left: scrollLeft,
		      behavior: 'smooth'
		    });
	    } else {
		    this.smoothScrollPolyfill(this.numbers, 'scrollLeft', scrollLeft);
	    }
	}
	
	scrollNumbers(el, e) {
		clearTimeout(this.numberScrollEnd);
		var that = this;
		this.numberScrollEnd = setTimeout(function() {
			var slide = Math.floor(el.scrollLeft / el.getBoundingClientRect().width);
			var nav = el.parentNode.querySelectorAll('nav li a');
			for (var j = 0; j < nav.length; j++) {
				nav[j].classList.remove('active');
			}
			nav[slide].classList.add('active');
			that.currentSlide = slide;
		}, 100);
	}
}